<template>
  <div class="text-center section">
    <div class="d_flex_btwn">
      <h1 class="common_title">Working schedules</h1>
      <span>
        <router-link
          class="btn btn_black mr_10"
          :to="{ name: 'schedules-calender' }"
          >Calender view</router-link
        >
        <router-link class="btn btn_black" :to="{ name: 'schedules-all' }"
          >List view</router-link
        >
      </span>
    </div>
    <div class="ticket_contact_list_header">
      <div class="d_flex_btwn">
        <div class="order_filter_content">
          <div class="d_flex_start">
            <div class="width_260p">
              <Multiselect
                v-model="filter.user_id"
                :options="users"
                :multiple="false"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select a user"
                track-by="id"
                :optionHeight="20"
                :custom-label="userLabel"
                @Select="(selectedUser) => loadData(selectedUser)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-calendar
      class="custom-calendar max-w-full"
      :masks="masks"
      :attributes="attributes"
      disable-page-swipe
      is-expanded
    >
      <template v-slot:day-content="{ day, attributes }">
        <div class="flex flex-col h-full z-10 overflow-hidden">
          <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
          <div class="flex-grow overflow-y-auto overflow-x-auto">
            <p
              v-for="attr in attributes"
              :key="attr.key"
              class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
              :title="attr.customData.status"
              :class="attr.customData.class"
              @click="showData($event, attr.customData)"
            >
              {{ attr.customData.user_name }}
              {{ attr.customData.project_title }} - ({{
                attr.customData.start_time
              }}
              - {{ attr.customData.end_time }})
            </p>
          </div>
        </div>
      </template>
    </v-calendar>
    <div class="modal" :class="{ open_modal: showModal }" data-modal="modal">
      <div class="modal_overlay" data-modal-close="modal"></div>
      <div class="modal_wrap">
        <div class="modal_header">
          <div class="d_flex_btwn">
            <h3>Work schedule details - {{ this.scheduleData?.label }}</h3>
            <span>
              <span
                data-modal-close="modal"
                class="close_icon close_icon_md"
                @click.prevent="closeModal"
              ></span>
            </span>
          </div>
        </div>
        <div class="modal_inner">
          <div class="modal_content modal_850p">
            <div class="row">
              <div class="col_6 pr_20">
                <div class="form_row_inline">
                  <label class="">Name</label>
                  <div class="form_input">{{ scheduleData?.user_name }}</div>
                </div>
                <div class="form_row_inline">
                  <label class="">Date</label>
                  <div class="form_input">{{ scheduleData?.work_date }}</div>
                </div>
                <div class="form_row_inline">
                  <label class="">Time</label>
                  <div class="form_input">
                    {{ scheduleData?.start_time }} -
                    {{ scheduleData?.end_time }}
                  </div>
                </div>
                <div
                  :class="[
                    'form_row_inline',
                    { has_error: errorFor('status') },
                  ]"
                >
                  <label>Status</label>
                  <div class="form_input">
                    <select class="form_global" v-model="form.status">
                      <option value="pending">Pending</option>
                      <option value="in_progress">In progress</option>
                      <option value="completed">Completed</option>
                    </select>
                    <v-errors :errors="errorFor('status')"></v-errors>
                  </div>
                </div>
                <div class="form_row_inline">
                  <label></label>
                  <div class="form_input">
                    <button
                      class="btn btn_primary"
                      :disabled="lyLoading"
                      @click.prevent="update"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
              <div class="col_6 pr_20">
                <div class="form_row_inline">
                  <label class="">Project name</label>
                  <div class="form_input">
                    {{ scheduleData?.project_title }}
                  </div>
                </div>
                <div class="form_row_inline" v-if="scheduleData?.description">
                  <label class="">Details</label>
                  <div class="form_input">{{ scheduleData?.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: { Multiselect },
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      showModal: false,
      scheduleData: {},
      form: {
        status: '',
      },
      users: [],
      filter: {
        user_id: '',
      },
      selectedUser: null,
    };
  },
  created() {
    this.getUsers();
    this.loadData();
  },
  methods: {
    getUsers() {
      this.axios.get('/active-users-for-relation').then(({ data }) => {
        this.users = data.data;
      });
    },
    userLabel(option) {
      const user = this.users.find((user) => user.id === option);
      return user ? user.name : option.name;
    },
    loadData(user = null) {
      this.filter.user_id = user?.id;
      this.axios
        .get('/all-schedules-for-calender', { params: { ...this.filter } })
        .then((response) => {
          this.attributes = response.data.data;
        });
    },
    showData(e, data) {
      e.stopPropagation();
      this.scheduleData = { ...data };
      this.form.status = this.scheduleData.status;
      this.showModal = true;
    },
    closeModal() {
      this.scheduleData = {};
      this.showModal = false;
    },
    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/schedules/' + this.scheduleData.id, formData)
        .then(() => {
          this.selectedUser = this.users.find(
            (user) => user.id === this.filter.user_id
          );
          this.showSuccessMsg('Leave Update Successfully!');
          this.loadData();
          this.scheduleData = {};
          this.showModal = false;
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}

::v-deep(.custom-calendar.vc-container) {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;

  border-radius: 0;
  width: 100%;
}

::v-deep(.custom-calendar.vc-container .vc-header) {
  /* background-color: #f1f5f8; */
  /* padding: 10px 0; */
  height: 48px;
  margin-top: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weeks) {
  padding: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weekday) {
  background-color: var(--weekday-bg);
  border-bottom: var(--weekday-border);
  border-top: var(--weekday-border);
  padding: 5px 0;
}

::v-deep(.custom-calendar.vc-container .vc-day) {
  padding: 0 5px 3px 5px;
  text-align: left;
  height: var(--day-height);
  min-width: var(--day-width);
  background-color: white;
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1),
::v-deep(.custom-calendar.vc-container .vc-day.weekday-7) {
  background-color: #eff8ff;
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-bottom)) {
  border-bottom: var(--day-border);
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1:not(.on-bottom)) {
  border-bottom: var(--day-border-highlight);
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-right)) {
  border-right: var(--day-border);
}

::v-deep(.custom-calendar.vc-container .vc-day-dots) {
  margin-bottom: 5px;
}

::v-deep(.custom-calendar .vc-header .vc-title-wrapper .vc-title) {
  /* opacity: 1 !important; */
  /* background: red !important; */
  /* color: red; */
  background: transparent;
}
::v-deep(.custom-calendar .vc-header .vc-title:hover) {
  opacity: 1;
}

::v-deep(.custom-calendar .vc-weeks .vc-day) {
  text-align: center;
  padding: 5px;
  min-height: 60px;
  height: auto;
}
::v-deep(.custom-calendar .bg-info) {
  background: rgba(66, 153, 225);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-success) {
  background: rgba(56, 178, 172);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-green) {
  background: #16a34a;
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
.color_green {
  color: #16a34a;
}
.text-danger {
  color: #dc2626;
}
.float-right {
  float: right;
  cursor: pointer;
}
</style>
